import styled from 'styled-components';

import { StyleColor, NewStyleColor } from '../../../utils/styles-constants';

interface StyledButtonSendProps {
	disabled: boolean;
}

const StyledButtonSend = styled('button')`
	margin-left: 20px;
	margin-right: 44px;
	padding: 5px 14px;
	border: 0;
	border-radius: 12px;
	outline: 0;
	font-size: 16px;
	line-height: 16px;
	background-color: ${StyleColor.Blue600};
	color: ${NewStyleColor.White};
	cursor: pointer;
	transition: background-color 0.2s;
	white-space: nowrap;

	${(props: StyledButtonSendProps) => props.disabled && `
		cursor: default;
		opacity: 0.5;
	`}

	&:hover {
		background-color: ${StyleColor.Blue300};
	}
`;

export {
	StyledButtonSend,
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/ButtonSend/styles.ts